//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreOrderTypesAsync } from "./instoreOrderTypesSlice";
import { useEffect } from "react";
import InstoreOrderTypesContainer from "../../components/instoreOrderTypes/InstoreOrderTypesContainer";
//#endregion

export default function InstoreTypesPage() {
  //#region SETUP
  const dispatch = useAppDispatch();
  const { instoreOrderTypes_Loaded } = useAppSelector(
    ({ instoreOrderTypes }) => instoreOrderTypes
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchOnload = async () => {
      if (!instoreOrderTypes_Loaded) {
        await dispatch(fetchInstoreOrderTypesAsync());
      }
    };
    fetchOnload();
  }, [instoreOrderTypes_Loaded, dispatch]);
  //#endregion

  return <InstoreOrderTypesContainer />;
}
